//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '@/common/common';
export default {
    name: 'online-waybill-item',
    props: ['item', 'type'],
    computed: {
        createTime: function () {
            return common.formatTime(
                'YYYY-mm-dd HH:MM',
                new Date(this.item.createTime)
            );
        }
    },
    methods: {
        // 发送消息
        sendMessage() {
            this.$emit('sendMessage');
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/chat/waybillItem.vue